'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dataProvider = require('./data-provider');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_dataProvider).default;
    }
});
Object.defineProperty(exports, 'defaultTunnel', {
    enumerable: true,
    get: function get() {
        return _dataProvider.defaultTunnel;
    }
});
Object.defineProperty(exports, 'TunnelType', {
    enumerable: true,
    get: function get() {
        return _dataProvider.TunnelType;
    }
});

var _config = require('./config');

Object.defineProperty(exports, 'init', {
    enumerable: true,
    get: function get() {
        return _config.setConfig;
    }
});
Object.defineProperty(exports, 'getProxy', {
    enumerable: true,
    get: function get() {
        return _config.getProxy;
    }
});
Object.defineProperty(exports, 'ProviderConfigType', {
    enumerable: true,
    get: function get() {
        return _config.ProviderConfigType;
    }
});

var _getEndpoint = require('./get-endpoint');

Object.defineProperty(exports, 'getEndpoint', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_getEndpoint).default;
    }
});

var _userLinks = require('./user-links');

Object.defineProperty(exports, 'getUserLinksData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_userLinks).default;
    }
});
Object.defineProperty(exports, 'UserLinkListType', {
    enumerable: true,
    get: function get() {
        return _userLinks.UserLinkListType;
    }
});
Object.defineProperty(exports, 'UserLinkRecordType', {
    enumerable: true,
    get: function get() {
        return _userLinks.UserLinkRecordType;
    }
});

var _paymentProviders = require('./payment-providers');

Object.defineProperty(exports, 'getPaymentProviderData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_paymentProviders).default;
    }
});
Object.defineProperty(exports, 'PaymentProviderListType', {
    enumerable: true,
    get: function get() {
        return _paymentProviders.PaymentProviderListType;
    }
});
Object.defineProperty(exports, 'PaymentProviderRecordType', {
    enumerable: true,
    get: function get() {
        return _paymentProviders.PaymentProviderRecordType;
    }
});

var _productNav = require('./product-nav');

Object.defineProperty(exports, 'getProductNavData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_productNav).default;
    }
});
Object.defineProperty(exports, 'ProductListType', {
    enumerable: true,
    get: function get() {
        return _productNav.ProductListType;
    }
});
Object.defineProperty(exports, 'ProductRecordType', {
    enumerable: true,
    get: function get() {
        return _productNav.ProductRecordType;
    }
});

var _footerLinks = require('./footer-links');

Object.defineProperty(exports, 'getFooterLinksData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_footerLinks).default;
    }
});
Object.defineProperty(exports, 'FooterLinkListType', {
    enumerable: true,
    get: function get() {
        return _footerLinks.FooterLinkListType;
    }
});
Object.defineProperty(exports, 'FooterLinkRecordType', {
    enumerable: true,
    get: function get() {
        return _footerLinks.FooterLinkRecordType;
    }
});
Object.defineProperty(exports, 'FooterLinkRecord', {
    enumerable: true,
    get: function get() {
        return _footerLinks.FooterLinkRecord;
    }
});

var _languages = require('./languages');

Object.defineProperty(exports, 'getLanguageData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_languages).default;
    }
});
Object.defineProperty(exports, 'LanguageRecordType', {
    enumerable: true,
    get: function get() {
        return _languages.LanguageRecordType;
    }
});
Object.defineProperty(exports, 'LanguageMapType', {
    enumerable: true,
    get: function get() {
        return _languages.LanguageMapType;
    }
});

var _regulatory = require('./regulatory');

Object.defineProperty(exports, 'getRegulatoryData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_regulatory).default;
    }
});
Object.defineProperty(exports, 'LogoRecordType', {
    enumerable: true,
    get: function get() {
        return _regulatory.LogoRecordType;
    }
});
Object.defineProperty(exports, 'LogosListType', {
    enumerable: true,
    get: function get() {
        return _regulatory.LogosListType;
    }
});
Object.defineProperty(exports, 'RegulatoryRecordType', {
    enumerable: true,
    get: function get() {
        return _regulatory.RegulatoryRecordType;
    }
});
Object.defineProperty(exports, 'RegulatoryRecord', {
    enumerable: true,
    get: function get() {
        return _regulatory.RegulatoryRecord;
    }
});

var _translationToken = require('./translation-token');

Object.defineProperty(exports, 'getTranslationTokenData', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_translationToken).default;
    }
});
Object.defineProperty(exports, 'TranslationListType', {
    enumerable: true,
    get: function get() {
        return _translationToken.TranslationListType;
    }
});

var _promoCodes = require('./promo-codes');

Object.defineProperty(exports, 'getPromoCodes', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_promoCodes).default;
    }
});
Object.defineProperty(exports, 'PromoDataRecordType', {
    enumerable: true,
    get: function get() {
        return _promoCodes.PromoDataRecordType;
    }
});
Object.defineProperty(exports, 'PromoDataRecord', {
    enumerable: true,
    get: function get() {
        return _promoCodes.PromoDataRecord;
    }
});

var _balance = require('./balance');

Object.defineProperty(exports, 'getBalance', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_balance).default;
    }
});

var _rewards = require('./rewards');

Object.defineProperty(exports, 'getRewardState', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_rewards).default;
    }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/index.js
// module id = 175
// module chunks = 0